/**
 * IMPORTS
 */
import AxiosService from "@/infra/http/axios";
import { IRemessasResponse, ISearchShipmentRepository } from "@/interface/search-shipment";

const searchSpnmentRepository: ISearchShipmentRepository = {
  /**
   * Função para buscar remessas
   * @param accessToken
   * @returns Promise<any | null>
   */
  async getAllSearchShipment(
    accessToken: string,
    currentPage: number = 1,
    itemsPerPage: number = 5,
    searchItem = ""
  ): Promise<IRemessasResponse | null> {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const remessas = await Instance.get<IRemessasResponse>(
      `remessas?page=${currentPage}&per_page=${itemsPerPage}&search=${searchItem}`,
      {
        headers: {
          "content-type": "application/json; charset=UTF-8",
          accept: "*/*",
        },
      }
    );

    return remessas?.data;
  },
};

/**
 * EXPORTS
 */
export { searchSpnmentRepository };
